import React from "react";
import * as yup from "yup";

import { PaziaInput } from "components/atoms";
import { QuestionForm } from "./QuestionForm";
import { useSurvey } from "pages/SurveyCreate/store/reducer";
import { questionBaseSchema } from "./BaseQuestionForm";
import { Question } from "survey";

interface RatingQuestionFormProps {
  question: Question;
}
export const RatingQuestionForm = ({ question }: RatingQuestionFormProps) => {
  const { dispatch } = useSurvey();

  const updateLabel = (fieldName: string, e: React.ChangeEvent<HTMLInputElement>) =>
    dispatch({
      type: "UPDATE_QUESTION",
      payload: { ...question, [fieldName]: e.target.value },
    });

  return (
    <QuestionForm question={question}>
      <div className="grid grid-cols-2 gap-4">
        <PaziaInput
          label="Niska etykieta"
          name={QUESTION_RATING_FORM_NAMES.LOWER_LABEL}
          onChange={(e) => updateLabel(QUESTION_RATING_FORM_NAMES.LOWER_LABEL, e)}
        />
        <PaziaInput
          label="Wysoka etykieta"
          name={QUESTION_RATING_FORM_NAMES.UPPER_LABEL}
          onChange={(e) => updateLabel(QUESTION_RATING_FORM_NAMES.UPPER_LABEL, e)}
        />
      </div>
    </QuestionForm>
  );
};

export const QUESTION_RATING_FORM_NAMES = {
  LOWER_LABEL: "lowerLabel",
  UPPER_LABEL: "upperLabel",
} as const;

const questionRatingQuestionSchema = yup
  .object({
    [QUESTION_RATING_FORM_NAMES.LOWER_LABEL]: yup.string(),
    [QUESTION_RATING_FORM_NAMES.UPPER_LABEL]: yup.string(),
  })
  .required();

export const ratingQuestionSchema = questionRatingQuestionSchema.concat(questionBaseSchema);
export type RatingQuestionFormValues = yup.InferType<typeof ratingQuestionSchema>;
